import React from 'react';
import UN_ICONS_TYPOGRAPHY_VARIANT from 'types/unacademyIcons/typography.type';
import styled from '@emotion/styled';
import ChevronRight from '@icon/ChevronRight';
import Typography from '@unicons-base/Typography/Typography';
import { Fonts, Spacings } from '@styles/index';

interface MainMenuItemProps {
  title: string;
  settingKey: any;
  settingValue: any;
  handleSettingClick: (settingKey: any) => void;
}

const MenuItem = styled.li`
  padding: ${Spacings.SPACING_2B} ${Spacings.SPACING_4B};
  width: 100%;
  display: flex !important;
  justify-content: space-between;
  min-width: 252px;
  margin: 0;
  cursor: pointer;
  margin: 0;
  &:hover {
    opacity: 0.8;
    background: var(--color-i-icon-light-hover);
  }
`;

const ItemText = styled(Typography)`
  cursor: pointer;
  color: white;
  margin-bottom: 0;
`;

const StyledChevronRight = styled(ChevronRight)`
  margin-left: 12px;
`;

const SelectedItemText = styled(Typography)`
  display: flex;
  font-weight: ${Fonts.BOLD};
  cursor: pointer;
  align-items: center;
  margin-bottom: 0;
`;

const MainMenuItem: React.FC<MainMenuItemProps> = ({
  title,
  settingKey,
  settingValue,
  handleSettingClick
}) => {
  return (
    <MenuItem onClick={() => handleSettingClick(settingKey)}>
      <ItemText variant={UN_ICONS_TYPOGRAPHY_VARIANT.BODY1}>{title}</ItemText>{' '}
      <SelectedItemText variant={UN_ICONS_TYPOGRAPHY_VARIANT.BODY1}>
        {settingValue}
        <StyledChevronRight
          size="14px"
          strokeWidth="4px"
          aria-hidden="true"
          color="var(--color-i-icon-light-tertiary)"
        />
      </SelectedItemText>
    </MenuItem>
  );
};

MainMenuItem.displayName = 'MainMenuItem';

export default MainMenuItem;
